import React from 'react';
import { EditorLeftSidebar } from '../../../../features/editor-left-sidebar';
import { EDITOR_CONTAINER_ID } from '../../../../features/editor-left-sidebar/config';

type Props = {
  children: React.ReactNode;
};

export const TemplateEditorWrapper: React.FC<Props> = ({ children }) => {
  return (
    <>
      <EditorLeftSidebar />
      <div
        className="relative flex-grow flex flex-col overflow-hidden h-[calc(100vh-68px)] max-w-256"
        id={EDITOR_CONTAINER_ID}
      >
        <div className="flex-grow bg-base-white rounded-2xl h-[calc(100vh-68px)] overflow-y-auto border-base-black/[0.04] border">
          {children}
        </div>
      </div>
      <div className="w-20" />
    </>
  );
};
